import { HttpContextToken } from '@angular/common/http';

/** Set on HTTP requests that should not show an automatic error toast (e.g. background refresh). */
export const SKIP_ERROR_TOAST = new HttpContextToken<boolean>(() => false);
